import { useContext, useState } from "react";
import AdministratorsContext from "../../../context/AdministratorsContext/AdministratorsContext";
import { Dialog } from "@material-ui/core";
import { clearAdministratorsModal } from "../../../context/AdministratorsContext/Actions";
import styles from "../../Payroll/Modals/PayrollModals.module.css";
import { DELETE_ADMIN_USERS, GET_ALL_USER_ADMIN } from "../../../Querys/querys";
import { useMutation } from "@apollo/client";
import { SuccessfulAlert } from "../../../alerts/successAlerts";

export const DeleteAdministrators2 = () => {
  const { state, dispatch } = useContext(AdministratorsContext);
  const [activo, setactivo] = useState(false);
  const handleChange = (e: any) => {
    if (e.target.value === "ELIMINAR") {
      setactivo(true);
    } else {
      setactivo(false);
    }
  };

  const [deleteAdminUser] = useMutation(DELETE_ADMIN_USERS, {
    refetchQueries: [{ query: GET_ALL_USER_ADMIN }],
  });

  const handleClose = () => {
    clearAdministratorsModal({}, dispatch);
  };

  const handleDelete = async () => {

    await deleteAdminUser({
      variables: {
        id: state._id,
      },
    });

    SuccessfulAlert({ text: "Administrador eliminado correctamente" });
    handleClose();
  };

  return (
    <Dialog
      open={state.deleteModal}
      aria-labelledby="form-dialog-title"
      maxWidth={"md"}
    >
      <div className={styles.em_container}>
        <div className={styles.contenedorCerrarModal}>
          <div
            className={styles.cerrarModal}
            onClick={() => handleClose()}
          ></div>
        </div>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.iconoEliminar}></div>
          <div className={styles.em_titulo}>
            ¿Est&aacute;s seguro de que quieres eliminar el registro?
          </div>
          <div className={styles.em_mensajePrtincipal}>
            <span>
              Una vez eliminado el usuario dejar&aacute; de tener acceso
            </span>
            <br />
            <span className={styles.em_textoPrincipal}>
              Escribe ELIMINAR para confirmar
            </span>
          </div>
          <div>
            <input
              className={styles.input}
              type="text"
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
      </div>
      <div className={styles.em_contenedorBotones}>
        <button
          className={styles.em_botonCancelar}
          onClick={() => handleClose()}
        >
          Cancelar
        </button>
        {activo === true ? (
          <button
            className={styles.em_botonConfirmarActivo}
            onClick={() => handleDelete()}
          >
            <div className={styles.em_iconoConfirmarEliminar}></div>
            <div>Confirmar</div>
          </button>
        ) : (
          <button className={styles.em_botonConfirmarInactivo}>
            <div className={styles.em_iconoConfirmarEliminar}></div>
            <div>Confirmar</div>
          </button>
        )}
      </div>
    </Dialog>
  );
};
